import { format } from 'date-fns';

export const getDueText = ({ dueDate }) => {
  const displayDate = format(new Date(dueDate), 'h:mmaaa, EEEE d MMMM');

  return `By ${displayDate}`;
};
